module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"New filter value":"Neuer Filterwert"}}')
  delete Component.options._Ctor
}
